import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import CSSModules from "react-css-modules";
import styles from "./cardMakeAPayment.scss";
import DebitCardForm from "../components/common/debitCardForm/DebitCardForm";
import DatePicker from "../components/common/material/DatePicker";
import LoadingBlocking from '../components/loading/LoadingBlocking';
import * as cardActions from "./redux";
import _get from "utils/get";
import * as FormatUtils from "utils/formatUtils";
import RaisedButton from "components/common/material/RaisedButton";
import { FormattedMessage } from "react-intl";
import vSignImage from "./public/vSign.png";
import * as thunkActionHelpers from "utils/redux/thunkActionHelpers";
import ErrorDialog from './CardDialogs/ErrorDialog/ErrorDialog';
import PaymentMethodSelect from "./makeAPayment/PaymentMethodSelect";
import AmountOptions from "./makeAPayment/AmountOptions";
import { trackEvent } from "../reducers/analyticsReducer";
import {Splash} from "../components/modal/Modal";
import {getMainCard, getSunbitCard4LastDigits} from "./cardHelper";
import { datadogRum } from "@datadog/browser-rum";
import InfoBox from "../components/common/info-box/info-box";

/* eslint-disable react/no-multi-comp */

const today = new Date();

const formatPaymentDate = value => {
  const formattedDate = FormatUtils.transformDate(value);
  const formattedToday = FormatUtils.transformDate(new Date());
  if (formattedDate === formattedToday) {
    return "Today " + formattedDate;
  }
  return formattedDate;
};

const defaultPaymentErrorMessageKey = "card.autopay.error.PaymentProfileError";

@connect(
  state => ({
    card: state.card
  }),
  dispatch => ({
    trackEvent: (event, properties) => dispatch(trackEvent(event, properties)),
    getBalance: () => dispatch(cardActions.getBalance()),
    getStatement: statementDate =>
      dispatch(cardActions.getStatement(statementDate)),
    getCardAccount: () => dispatch(cardActions.fetch()),
    cardMakePayment: paymentDetails => dispatch(cardActions.cardMakePayment(paymentDetails)),
    setAutoPay: (enabled, peymentMethodDetails) => dispatch(cardActions.setAutoPay(enabled, peymentMethodDetails)),
  })
)
@CSSModules(styles, { allowMultiple: true })
class CardMakeAPayment extends React.Component {
  static propTypes = {
    getBalance: PropTypes.func,
    getStatement: PropTypes.func,
    getCardAccount: PropTypes.func,
    cardMakePayment: PropTypes.func,
    trackEvent: PropTypes.func,
    card: PropTypes.object,
    setAutoPay: PropTypes.func,
  };

  constructor(props) {
    super(props);
   this.init();
  }

  init = () => {
    const paymentMethodType = _get(this, ["props", "card", "card", "paymentMethod", "paymentMethodType"], null);
    this.state = {
      amountOption: undefined,
      paymentMethod: paymentMethodType === "DEBIT" ? "CURRENT" : "NEW",
      amount: undefined,
      debitCardDetailsFullData: { debitCardDetails: undefined}, // include if its set as default or not
      paymentDate: new Date(),
      step: "PAYMENT",
      last4Digits: "",
      sunbitCard4LastDigits: "",
      otherAmountErrors: [],
      otherAmountMessages: [],
      otherAmountRawValue: "",
      paymentInProcess: false,
      completedPayment: {},
      showNotPayableDialog: false,
      isLoading : false,
      paymentErrorMessageKey: defaultPaymentErrorMessageKey
    };
    this.moveToReview = this.moveToReview.bind(this);
    this.cancelPayment = this.cancelPayment.bind(this);
    this.handleDebitCardFormChange = this.handleDebitCardFormChange.bind(this);
    this.handleOtherAmountChanged = this.handleOtherAmountChanged.bind(this);
    this.makeAPayment = this.makeAPayment.bind(this);
    this.renderNotPayableDialog = this.renderNotPayableDialog.bind(this);
    this.toggleNotPayableDialog = this.toggleNotPayableDialog.bind(this);
    this.failedPaymentReturn = this.failedPaymentReturn.bind(this);
  };

  componentDidMount() {
    this.props.getCardAccount();
    this.props.getBalance();
    this.props.getStatement();
  }

  componentDidUpdate() {
    const mainCard = getMainCard(_get(this.props, ["card", "card", "cards"], []));
    const sunbitCard4LastDigits = getSunbitCard4LastDigits(mainCard);
    if (this.state.sunbitCard4LastDigits !== sunbitCard4LastDigits) {
      this.setState({ sunbitCard4LastDigits });
    }
  }

  componentWillReceiveProps(nextProps) {
    const propsPaymentMethodType = _get(
      this,
      ["props", "card", "card", "paymentMethod", "paymentMethodType"],
      null
    );
    const nextPropsPaymentMethodType = _get(
      nextProps,
      ["card", "card", "paymentMethod", "paymentMethodType"],
      null
    );
    if (
      propsPaymentMethodType === null &&
      nextPropsPaymentMethodType !== null
    ) {
      this.setState({
        paymentMethod:
          nextPropsPaymentMethodType === "DEBIT" ? "CURRENT" : "NEW"
      });
    }
    if (!this.isPaymentSuccess() && this.isPaymentSuccess(nextProps)) {
      this.setState({
        isLoading : false,
        completedPayment: nextProps.card.payment
      }, this.handlerPaymentSuccess);
    }

    if (!this.isPaymentPending() && this.isPaymentPending(nextProps)) {
      this.setState({ paymentInProcess: true,
                            completedPayment: {} });
    }

    if (!this.isPaymentFailed() && this.isPaymentFailed(nextProps)) {
      const error = _get(nextProps.card, ["error", "response", "data"], null);
      const errorCode = _get(error, ["code"], null);      
      let paymentErrorMessageKey;
      switch (errorCode) {
        case "TransactionDeclined":
          paymentErrorMessageKey = "card.autopay.error.TransactionDeclined";
          break;
        case "bankruptAccount":
          paymentErrorMessageKey = "card.payment.error.bankrupt.account";
          break;
        case "WrongCardType":
          paymentErrorMessageKey = "card.autopay.error.WrongCardType";
          break;
        case "PaymentProfileError":
        default:
          paymentErrorMessageKey = defaultPaymentErrorMessageKey;
          break;
      }

      this.setState({
              paymentInProcess: false,
              isLoading : false,
              paymentErrorMessageKey: paymentErrorMessageKey
        }, () => this.toggleNotPayableDialog());

      datadogRum.addUserAction('Make a payment card failed', {
        customerId: nextProps.card.card.customerId,
        error
      })
    }

    if (!this.isCardSetAutoPaySuccess() && this.isCardSetAutoPaySuccess(nextProps)) {
      this.setState({ paymentInProcess: false,
                            isLoading : false,
                            step: "CONFIRMATION",});
    }
    if (!this.isCardSetAutoPayFailed() && this.isCardSetAutoPayFailed(nextProps)) {
      this.setState({ paymentInProcess: false,
                            isLoading : false,
                            step: "CONFIRMATION",});
    }
  }

  handlerPaymentSuccess = () => {
    const {debitCardDetailsFullData } = this.state;
    const autoPay = _get(this.props, ['card', 'card', 'autoPaySetting', 'enabled'], false);
    const customerId = _get(this.props, ['card', 'card', 'customerId'], -1);
    const paymentMethodType = _get(this.state, ['completedPayment', 'paymentMethod', 'paymentMethodType'], "");
    datadogRum.addUserAction('Make a payment card success', {
      customerId,
      paymentMethodType
    })
    if(debitCardDetailsFullData.isDefaultPayment) { // if the user want set the credit card as default
      let paymentMethodDetails = {debitCardDetails : debitCardDetailsFullData.debitCardDetails, paymentMethodType };
      this.props.setAutoPay(autoPay ,paymentMethodDetails);
    } else {
      this.setState({ paymentInProcess: false ,
                            step: "CONFIRMATION",});
    }
  };

  isPaymentSuccess(props) {
    props = props || this.props;
    return thunkActionHelpers.actionSuccess(
      cardActions.CARD_MAKE_PAYMENT,
      props.card.type,
      props.card.status
    );
  }

  isPaymentPending(props) {
    props = props || this.props;
    return thunkActionHelpers.actionPending(
      cardActions.CARD_MAKE_PAYMENT,
      props.card.type,
      props.card.status
    );
  }

  isPaymentFailed(props) {
    props = props || this.props;
    return thunkActionHelpers.actionFail(
      cardActions.CARD_MAKE_PAYMENT,
      props.card.type,
      props.card.status
    );
  }
 // todo need to be in an outsider service
  isCardSetAutoPaySuccess(props) {
    props = props || this.props;
    return thunkActionHelpers.actionSuccess(
      cardActions.CARD_SET_AUTOPAY,
      props.card.type,
      props.card.status
    );
  }

  isCardSetAutoPayFailed(props) {
    props = props || this.props;
    return thunkActionHelpers.actionFail(
      cardActions.CARD_SET_AUTOPAY,
      props.card.type,
      props.card.status
    );
  }

  handleAmountOptionSelection = value => {
    const statement = this.getLastStatement(
      _get(this, ["props", "card", "statement"])
    );
    const balance = _get(this, ["props", "card", "balance"], null);
    const { statementEndingBalance } = statement || {
      statementEndingBalance: 0
    };
    const currentBalanceAmount = balance ? balance.currentBalanceAmount : 0;
    const currentMinimumPaymentDueAmount = balance
      ? balance.currentMinimumPaymentDueAmount
      : 0;

    let amount = 0;
    switch (value) {
      case "STATEMENT_BLANACE":
        amount = statementEndingBalance;
        break;
      case "CURRENT_BLANACE":
        amount = currentBalanceAmount;
        break;
      case "MINIMUM_PAYMENT":
        amount = currentMinimumPaymentDueAmount;
        break;
    }

    this.setState(() => ({
      amountOption: value,
      amount,
      otherAmountRawValue: String(amount),
      otherAmountErrors: [],
      otherAmountMessages: []
    }));
  };

  handlePaymentMethodSelection = value => {
    this.setState(() => ({ paymentMethod: value }));
  };

  handleDebitCardFormChange = (debitCardDetailsFullData, name) => {
    this.setState(() => ({ [name]: debitCardDetailsFullData }));
  };

  handleOtherAmountChanged = event => {
    const numberRegex = /^\s*[+-]?(\d+|\.\d+|\d+\.\d{0,2}|\d+\.)(e[+-]?\d+)?\s*$/;
    const balance = _get(this, ["props", "card", "balance"], null);

    const currentBalanceAmount = balance ? balance.currentBalanceAmount : 0;
    const currentMinimumPaymentDueAmount = balance
      ? balance.currentMinimumPaymentDueAmount
      : 0;

    const rawValue = event.target.value;
    if (rawValue !== "" && numberRegex.test(rawValue) === false) {
      return;
    }
    let value = rawValue === "" ? undefined : Number(rawValue);
    const errors = [];
    const messages = [];
    if (Number.isNaN(value)) {
      errors.push("Invalid amount");
    }
    if (value < 2) {
      errors.push("The minimum payment amount is $2");
    }
    if (value > currentBalanceAmount) {
      errors.push(
        `The amount entered exceeds your total balance of $${currentBalanceAmount}.`
      );
    }
    if (value < currentMinimumPaymentDueAmount) {
      messages.push(
        "To avoid late fees, you may want to adjust your payment to the minimum payment due or make another payment before your due date."
      );
    }
    this.setState(() => ({
      otherAmountRawValue: rawValue,
      amount: value,
      otherAmountErrors: errors,
      otherAmountMessages: messages,
      amountOption: "OTHER"
    }));
  };

  otherAmountInput = (disabled) => {
    return (
      <div styleName="otherAmountInputWrap">
        <div>
          ${" "}
          <input
            type="text"
            disabled={disabled}
            name="otherAmount"
            value={this.state.otherAmountRawValue}
            onChange={this.handleOtherAmountChanged}
            data-at="other-amount-input"
          />
        </div>
      </div>
    );
  };

  handlePaymentDateChanged = date => {
    this.setState(() => ({ paymentDate: date }));
  };

  getLastStatement(statement) {
    if (!statement) {
      return;
    }
    return statement[Object.keys(statement)[0]];
  }

  makeAPayment() {
    this.setState({isLoading : true} ,
      () => {  const paymentDetails = {
                          amount: this.state.amount
                        };
                        if (this.state.paymentMethod === "NEW") {
                          paymentDetails["newPaymentProfile"] = {
                            debitCardDetails: this.state.debitCardDetailsFullData.debitCardDetails,
                            paymentMethodType: "DEBIT"
                          };
                        }
                        this.props.cardMakePayment(paymentDetails);
                    });
  }

  renderMakeAPayment() {
    const statement = this.getLastStatement(
      _get(this, ["props", "card", "statement"])
    );
    const balance = _get(this, ["props", "card", "balance"], null);
    const last4Digits = _get(
      this,
      ["props", "card", "card", "paymentMethod", "last4Digits"],
      null
    );

    const paymentMethodType = _get(
      this,
      ["props", "card", "card", "paymentMethod", "paymentMethodType"],
      null
    );

    const { statementEndingBalance } = statement || {
      statementEndingBalance: 0
    };
    const currentBalanceAmount = balance ? balance.currentBalanceAmount : 0;
    const currentMinimumPaymentDueAmount = balance
      ? balance.currentMinimumPaymentDueAmount
      : 0;

    const allDisabled = currentBalanceAmount === 0;

     const showSetDefaultPaymentMethodCheckbox = true;
    return (
      <div>
        <h1 styleName="title" data-at="subtitle-payment-lable">
          Make a Payment
        </h1>
        <div styleName="cardMakeAPaymentInner">
          <section styleName="commonSection amountSection">
            <h2 styleName="sectionTitle" data-at="amount-header-text">
              Amount
            </h2>
            <AmountOptions
              allDisabled={allDisabled}
              selected={this.state.amountOption}
              onChange={this.handleAmountOptionSelection}
              otherAmountInput={this.otherAmountInput(allDisabled)}
              statementEndingBalance={statementEndingBalance || 0}
              currentBalanceAmount={currentBalanceAmount || 0}
              statementPaymentAmount={currentMinimumPaymentDueAmount}
              errors={this.state.otherAmountErrors}
            />
            {this.state.otherAmountErrors.length > 0 && (
                <InfoBox
                  dataAt="errorContainer"
                  type="error"
                  body={this.state.otherAmountErrors[0]}
                />
            )}
            {this.state.otherAmountMessages.length > 0 &&
              this.state.otherAmountErrors.length === 0 && (
                <InfoBox
                  dataAt="messageContainer"
                  type="warning"
                  body={this.state.otherAmountMessages[0]}
                />
              )}
            {allDisabled && (
              <InfoBox
                dataAt="messageContainer"
                type="warning"
                body="Your current balance is $0.00, so a payment cannot be made at this time."
              />
            )}
          </section>
          <section styleName="commonSection paymentMethodSection">
            <h2 styleName="sectionTitle" data-at="payment-method-header-text">
              Payment Method
            </h2>
            <PaymentMethodSelect
              selected={this.state.paymentMethod}
              last4Digits={last4Digits || ""}
              onChange={this.handlePaymentMethodSelection}
              showCurrent={paymentMethodType === "DEBIT"}
            />
            {this.state.paymentMethod === "NEW" && (
              <DebitCardForm
                showSetDefaultPaymentMethodCheckbox={
                  showSetDefaultPaymentMethodCheckbox
                }
                name="debitCardDetailsFullData"
                onChange={this.handleDebitCardFormChange}
              />
            )}
          </section>
          <section styleName="commonSection paymentDateSecion">
            <h2 styleName="sectionTitle" data-at="payment-date-header-text">
              Payment Date
            </h2>
            <DatePicker
              readonly={true}
              autoOk={true}
              minDate={today}
              inputFormat={formatPaymentDate}
              theme={{
                input: styles.datePicker,
                inputElement: styles.datePickerInput,
              }}
              value={this.state.paymentDate}
              onChange={this.handlePaymentDateChanged}
              data-at={`date-picker`}
            />
          </section>
        </div>
      </div>
    );
  }

  renderReviewTable() {
    return (
      <div styleName="reviewTable">
        <div styleName="row">
          <div styleName="label" data-at="confirmation-debit-card-title">Debit Card</div>
          <div styleName="value" data-at="confirmation-debit-card-value">Debit Card ending in {this.state.last4Digits}</div>
        </div>
        <div styleName="row">
          <div styleName="label" data-at="confirmation-amount-title">Amount</div>
          <div styleName="value" data-at="confirmation-amount-value">{FormatUtils.addPriceSymbol(this.state.amount)}</div>
        </div>
        <div styleName="row">
          <div styleName="label" data-at="confirmation-date-title">Date</div>
          <div styleName="value" data-at="confirmation-date-value">{FormatUtils.transformDate(this.state.paymentDate)}</div>
        </div>
      </div>
    );
  }

  renderReviewPayment() {
    const {debitCardDetailsFullData, last4Digits , sunbitCard4LastDigits} = this.state;
    return (
      <div>
        <h1 styleName="title" data-at="subtitle-review-label">
          Review Payment Details
        </h1>
        <div styleName="cardMakeAPaymentInner">
          <section styleName="reviewSection">
            {this.renderReviewTable()}
          </section>
          {debitCardDetailsFullData.isDefaultPayment ?
          <section styleName="" data-at="confirmation-disclaimer">
            By clicking “Make Payment”, you authorize us to charge your debit card ending in {last4Digits}{" "} (the “Card”)
            for the amount you specify above today, and apply the payment to your Sunbit Card ending in {" "}{sunbitCard4LastDigits}.
            If we make an error in seeking payment, you authorize us to correct the error, on or after the due date it occurs,
            by initiating a charge or credit to the Card in the amount of the error.
            You also certify that you are an authorized user of the Card.
          </section> :
            <section>
              By clicking “Make Payment”, you authorize us to charge your debit card ending in {last4Digits}{" "} (the “Card”)
              for the amount you specify above today and for your AutoPay payments in accordance with your Payment Authorization,
              and apply the payment to your Sunbit Card ending in{" "}{sunbitCard4LastDigits}. If we make an error in seeking payment,
              you authorize us to correct the error, on or after the due date it occurs,
              by initiating a charge or credit to the Card in the amount of the error.
              You also certify that you are an authorized user of the Card.
            </section>}
        </div>
      </div>
    );
  }

  renderConfirmation() {
    const {debitCardDetailsFullData, last4Digits} = this.state;
    return (
      <div styleName="cardMakeAPayment confirmation">
        <header styleName="autoPayHeader">
          <img styleName="vSignImage" src={vSignImage} alt="v symbol" />
          <h1 styleName="title" data-at="subtitle-confirmation-label">
            We received your payment.
          </h1>
          {debitCardDetailsFullData.isDefaultPayment ?
            <p styleName="nextPaymentDateMessage">
              Your payment has been processed successfully and the debit card ending in {last4Digits} has been selected as your default payment method.
            </p> :
            <p styleName="nextPaymentDateMessage">
              Your payment has been processed successfully.
            </p>
          }
        </header>
        <section styleName="reviewSection">
          {this.renderReviewTable()}
        </section>
      </div>
    );
  }

  getLast4Digits() {
    let last4Digits = "";
    const currentLast4Digits = _get(
      this,
      ["props", "card", "card", "paymentMethod", "last4Digits"],
      null
    );
    if (this.state.paymentMethod === "NEW" && this.state.debitCardDetailsFullData.debitCardDetails) {
      last4Digits = this.state.debitCardDetailsFullData.debitCardDetails.cardNumber.substring(12);
    } else if (this.state.paymentMethod === "CURRENT") {
      last4Digits = currentLast4Digits;
    }
    return last4Digits;
  }

  moveToReview() {
    if (!this.isPaymentFormValid()) {
      return;
    }
    const last4Digits = this.getLast4Digits();
    this.setState({ last4Digits, step: "REVIEW" });

  }

  cancelPayment() {
    this.setState({ step: "PAYMENT" });
  }

  isPaymentFormValid() {
    if (this.state.otherAmountErrors.length > 0) {
      return false;
    }
    if (this.state.paymentMethod === "NEW" && !this.state.debitCardDetailsFullData.debitCardDetails) {
      return false;
    }
    if (!this.state.amount) {
      return false;
    }
    return true;
  }

  renderActions() {
    if (this.state.step === "PAYMENT") {
      return (
        <div styleName="continueButton">
          <div styleName="actionButton">
            <RaisedButton
              data-at="continueBtn"
              primary={true}
              onClick={this.moveToReview}
              disabled={!this.isPaymentFormValid()}>
              <FormattedMessage id="common.continue" />
            </RaisedButton>
          </div>
        </div>
      );
    }
    if (this.state.step === "REVIEW") {
      return (
        <div styleName="continueButton">
          <div styleName="actionButton">
            <RaisedButton
              data-at="cancelBtn"
              primary={false}
              onClick={this.cancelPayment}
              disabled={this.state.paymentInProcess}
            >
              <FormattedMessage id="common.cancel" />
            </RaisedButton>
          </div>
          <div styleName="actionButton">
            <RaisedButton
              data-at="makeAPaymentBtn"
              primary={true}
              onClick={this.makeAPayment}
              disabled={this.state.paymentInProcess}>
              <FormattedMessage id="card.action.makeAPayment" />
            </RaisedButton>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }

  toggleNotPayableDialog() {
    this.setState(() => ({
      showNotPayableDialog: !this.state.showNotPayableDialog
    }));
  }

  failedPaymentReturn() {
    this.setState(() => ({
      showNotPayableDialog: false,
      step: "PAYMENT",
      debitCardDetailsFullData: { debitCardDetails: undefined},
      paymentErrorMessageKey: defaultPaymentErrorMessageKey
    }));
  }


  renderNotPayableDialog() {
    return (<ErrorDialog onClose={this.failedPaymentReturn.bind(this)} isOpen={this.state.showNotPayableDialog}
                         paymentErrorMessageKey ={this.state.paymentErrorMessageKey}/>
    );
  }

  render() {
    return (
      <div styleName="cardMakeAPayment">
       <Splash isOpen={this.state.isLoading && this.state.step === "REVIEW"}/>
        { (this.state.isLoading && this.state.step !== "REVIEW") && <LoadingBlocking />}
        {  this.state.step === "PAYMENT" && this.renderMakeAPayment()}{" "}
        {  this.state.step === "REVIEW" && this.renderReviewPayment()}
        {  this.state.step === "CONFIRMATION" && this.renderConfirmation()}
        { this.renderActions()}
        { this.renderNotPayableDialog()}
      </div>
    );
  }
}

export default CardMakeAPayment;



// WEBPACK FOOTER //
// ./src/card/CardMakeAPayment.js